import { createSlice } from "@reduxjs/toolkit";
import {
  getAppointmentAnalysesEvents,
  getFirstAnalysesEvents,
  getSecondAnalysesEvents,
  getThirdAnalysesEvents,
  getFifthAnalysesEvents,
  getSixthAnalysesEvents,
  getStudyAnalysesEvents,
  getSeventhAnalysesEvents,
  getWaterfallAnalysesEvents,
  getFillAnalysesEvents,
  getEsignAnalysesEvents,
  getVoiceAnalysesEvents,
  getReminderAnalysesEvents,
  getReferralAnalysesEvents,
  getScheduleAnalysesEvents,
  getConfirmAnalysesEvents,
  getPenStudyAnalysesEvents,
  getSuperbillAnalysesEvents,
  getBookAnalysesEvents,
  getPatientAnalysesEvents,
  getStudyTasksEvents,
  getSuperbillTasksEvents,
  clearLocalAnalysesEvents,
  clearLocalTasksEvents
} from './actions';

export const initialState = {
  analysesEvents: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  tasksEvents: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  loading: {
    analysesEvents: false,
    tasksEvents: false
  }
}

const slice = createSlice({
  name: 'events',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getAppointmentAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getAppointmentAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getAppointmentAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getFirstAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getFirstAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getFirstAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getSecondAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getSecondAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getSecondAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getThirdAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getThirdAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getThirdAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getFifthAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getFifthAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getFifthAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getSixthAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getSixthAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getSixthAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getStudyAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getStudyAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getStudyAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getSeventhAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getSeventhAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getSeventhAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getWaterfallAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getWaterfallAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getWaterfallAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getFillAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getFillAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getFillAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getEsignAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getEsignAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getEsignAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getVoiceAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getVoiceAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getVoiceAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getReminderAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getReminderAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getReminderAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getReferralAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getReferralAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getReferralAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getScheduleAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getScheduleAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getScheduleAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getConfirmAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getConfirmAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getConfirmAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getPenStudyAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getPenStudyAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getPenStudyAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getSuperbillAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getSuperbillAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getSuperbillAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getBookAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getBookAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getBookAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getPatientAnalysesEvents.pending, (state) => {
        state.loading.analysesEvents = true;
      })
      .addCase(getPatientAnalysesEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.analysesEvents = false;
        state.analysesEvents.data = [...state.analysesEvents.data, ...events];
        state.analysesEvents.pagination = pagination;
      })
      .addCase(getPatientAnalysesEvents.rejected, (state) => {
        state.loading.analysesEvents = false;
      })
      .addCase(getStudyTasksEvents.pending, (state) => {
        state.loading.tasksEvents = true;
      })
      .addCase(getStudyTasksEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.tasksEvents = false;
        state.tasksEvents.data = [...state.tasksEvents.data, ...events];
        state.tasksEvents.pagination = pagination;
      })
      .addCase(getStudyTasksEvents.rejected, (state) => {
        state.loading.tasksEvents = false;
      })
      .addCase(getSuperbillTasksEvents.pending, (state) => {
        state.loading.tasksEvents = true;
      })
      .addCase(getSuperbillTasksEvents.fulfilled, (state, action) => {
        const { events, pagination } = action.payload;
        
        state.loading.tasksEvents = false;
        state.tasksEvents.data = [...state.tasksEvents.data, ...events];
        state.tasksEvents.pagination = pagination;
      })
      .addCase(getSuperbillTasksEvents.rejected, (state) => {
        state.loading.tasksEvents = false;
      })
      .addCase(clearLocalAnalysesEvents, state => {
        state.analysesEvents = initialState.analysesEvents;
      })
      .addCase(clearLocalTasksEvents, state => {
        state.tasksEvents = initialState.tasksEvents;
      })
  }
})


export default slice.reducer;